package fr.manyverse.app.domain.model

/**
 * Status of a digicode challenge.
 */
enum class DigicodeStatus {
    ACTIVE,
    SUCCESS,
    CANCELLED,
    TIMEOUT,
    FAILED
}
